module.exports = __webpack_public_path__ + "static/media/galerija_2023 (13).e5d916bb.png";